import React from "react"
import styled from "styled-components"
import { IRISBlueDivider, ReportText, TextSpan, TextLink } from "../components/Common/SharedStyledComponents";
import { IrisColors } from "../css/IRISColors";


const DashboardFooter = ({currentReport, isReport, releaseDate}) => {
    return (
        <Footer>
            <FooterInfoContainer>
                <IRISBlueDivider />
                <CenteredDiv>
                    <ReportText center>
                        IRIS is a national consortium of research universities whose members receive about 40% of total federal academic research funding. <br />IRIS produces reports and data to help understand, explain and improve higher education and research.
                    </ReportText>
                </CenteredDiv>
                {
                    isReport &&
                    <ReportText center>
                        <TextSpan bold>Citation: </TextSpan>
                        {currentReport && currentReport.fullName}, Institute for Research on Innovation and Science (IRIS), {releaseDate && releaseDate}
                    </ReportText>
                }
                <ReportText center>
                    <TextSpan bold>Website: </TextSpan><TextLink href="https://iris.isr.umich.edu/" target="_blank">iris.isr.umich.edu</TextLink>  |
                    <TextSpan bold>  Email: </TextSpan><TextLink href="mailto:IRIS-info@umich.edu" target="_blank">IRIS-info@umich.edu</TextLink>  |
                    <TextSpan bold>  LinkedIn: </TextSpan><TextLink href="https://www.linkedin.com/company/iris-um" target="_blank">LinkedIn</TextLink>
                </ReportText>
            </FooterInfoContainer>
            <FooterRights>
                <ReportText bold white center>
                    © {new Date().getFullYear()} Institute for Research on Innovation and Science (IRIS). All rights reserved.
                </ReportText>
            </FooterRights>
        </Footer>
    );
}


// main panel footer
const Footer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-inline: 15px;
    background-color: ${IrisColors.backgroundGrey};
`;

const FooterInfoContainer = styled.div`
    padding-inline: 15px;
    padding-block: 5px;
    background-color: ${IrisColors.white};
`;

const CenteredDiv = styled.div`
    max-width: 960px;
    margin-inline: auto;
`;

const FooterRights = styled.div`
    width: 100%;
    background-color: ${IrisColors.grey};
`;

export default DashboardFooter;